import OfferTilePricing from 'components/OfferList/OfferListTiles/Support/OfferTilePricing'
import { isCruiseOnlyOfferView, type CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import useCruisePriceByNight from 'hooks/useCruisePriceByNight'
import CruiseSearchTilePricing from './CruiseSearchTilePricing'
import useCruiseSelectedCabinType from 'hooks/useCruiseSelectedCabinType'
import { getCheapestCruiseFlashOfferByCabin } from 'lib/cruises/getCheapestCruiseFlashOfferByCabin'

interface Props {
  view: CruiseOfferView
}

function CruiseSearchTilePriceStack({ view }: Props) {
  const isPricePerNight = useCruisePriceByNight()
  const selectedCabinType = useCruiseSelectedCabinType(view.cruiseType)

  if (!isCruiseOnlyOfferView(view)) {
    const cheapestPackage = getCheapestCruiseFlashOfferByCabin({ offer: view.offer, cabinType: selectedCabinType || '' })
    return <OfferTilePricing
      offer={view.offer}
      isPricePerNight={isPricePerNight}
      pkg={cheapestPackage || view.offer.lowestPricePackage}
    />
  }

  return <CruiseSearchTilePricing view={view} />
}

export default CruiseSearchTilePriceStack
